import React from 'react';

interface MailPostIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const MailPostIcon: React.FC<MailPostIconProps> = ({
  className = '',
  size = 24,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.49951 2C4.01422 2.00002 1.99951 
      4.01475 1.99951 6.50004V15C1.99951 15.5523 
      2.44723 16 2.99951 16H9.99951C10.5518 16 10.9995 15.5523 10.9995 15V6
      .5C10.9995 4.01472 8.98479 2 6.49951 
      2ZM4.24976 8.5C3.83564 8.5 3.49989 
      8.16436 3.49976 7.75024C3.49962 7.33594 
      3.83545 7 4.24976 7H8.74976C9.16387 7 9.49962 7.33564 
      9.49976 7.74976C9.49989 8.16406 9.16406 8.5 8.74976 8.5H4.24976Z"
      fill={color}
    />
    <path
      d="M21.9999 15C21.9999 15.5523 
      21.5522 16 20.9999 16L13.9995 16V21C13.9995 
      21.5523 13.5518 22 12.9995 22C12.4472 22 
      11.9995 21.5587 11.9995 21.0064C11.9995 
      17.9791 11.9995 8.90005 11.9995 6C11.9995 3.5 
      9.67508 2.00022 9.67508 2.00022H16.9999C19.7613 2.00022 21.9999 4.23879 21.9999 7.00022V15Z"
      fill={color}
    />
  </svg>
);

export default MailPostIcon;
